import React from 'react';
import { withRouter } from 'react-router-dom';
import isNil from 'lodash/isNil';

import { RESULT_TYPE } from '../constant';
import { SOLUTION_SUB_ROUTES, EXAM_PAPER_ITEM_TYPE } from '../../../constant';
import { QueryComponent } from '../../../../../GraphQL';
import { getClassroomQuizExamPaperItemSolutionById } from '../../../../../GraphQL/query/Classroom.query';

const SolutionDetail = ({ solutionData, history, match, children }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(null);
  const { examId, examSessionId, examPaperItemId } = match.params;
  const { round, results, isShowScore } = solutionData;

  React.useEffect(() => {
    const currentQuestionIndex = getCurrentQuestionIndexById(examPaperItemId);
    setCurrentQuestionIndex(currentQuestionIndex);
  }, [examPaperItemId]);

  const getCurrentQuestionIndexById = (currentQuestionId) => {
    return results.findIndex((result) => {
      return currentQuestionId === result.id;
    });
  };

  const goToQuestion = (questionId, questionIndex) => {
    setCurrentQuestionIndex(questionIndex);
    history.push(SOLUTION_SUB_ROUTES.SOLUTION_DETAIL.getPath(examId, examSessionId, questionId));
  };

  const handleGoToSolutionListView = () => {
    history.push(SOLUTION_SUB_ROUTES.SOLUTION_LIST.getPath(examId, examSessionId, round));
  };

  const handleGoToNextQuestion = () => {
    if (currentQuestionIndex >= results.length - 1) {
      handleGoToSolutionListView();
    } else {
      const currentQuestionIndex = getCurrentQuestionIndexById(examPaperItemId);
      const nextQuestionId = results[currentQuestionIndex + 1].id;

      goToQuestion(nextQuestionId, currentQuestionIndex + 1);
    }
  };

  const handleGoToPreviousQuestion = () => {
    const currentQuestionIndex = getCurrentQuestionIndexById(examPaperItemId);
    const previousQuestionId = results[currentQuestionIndex - 1].id;

    goToQuestion(previousQuestionId, currentQuestionIndex - 1);
  };

  /**
   * @returns {{value: string, label: string, result: (keyof RESULT_TYPE)}[] | null}
   */
  const renderSelectedAnswer = (type, answer, correctAnswer, isCorrect, metadata = {}) => {
    if (isNil(answer?.value)) return null;

    let selectedAnswer = null;
    if (type === EXAM_PAPER_ITEM_TYPE.FILL_NUMBER) {
      selectedAnswer = [
        {
          value: answer.value,
          label: answer.value,
          result: isCorrect ? RESULT_TYPE.CORRECT : RESULT_TYPE.INCORRECT,
        },
      ];
    } else if (
      type === EXAM_PAPER_ITEM_TYPE.MULTIPLE_SELECT ||
      type === EXAM_PAPER_ITEM_TYPE.MULTIPLE_SELECT_WITH_CORRECT_ANSWERS
    ) {
      const answers = answer.value.split(',');
      const correctAnswers = correctAnswer.value?.split(',') ?? [];
      const { choices } = metadata;
      const _selectedAnswers = [];
      for (const answer of answers) {
        const choice = choices.find(({ value }) => value === answer);
        if (choice) {
          const isAnswerCorrect = correctAnswers.includes(answer);
          _selectedAnswers.push({
            value: answer,
            label: choice.label,
            result: isAnswerCorrect ? RESULT_TYPE.CORRECT : RESULT_TYPE.INCORRECT,
          });
        }
      }
      selectedAnswer = _selectedAnswers.length ? _selectedAnswers : null;
    } else if (type === EXAM_PAPER_ITEM_TYPE.CONNECTION) {
      const answers = answer.value.split(',');
      const correctAnswers = correctAnswer.value ? correctAnswer.value.split(',') : [];
      const usedAnswers = new Set(); // ใช้เก็บคำตอบที่เคยเจอ
      const _selectedAnswers = [];
      for (const answer of answers) {
        const isFirstTimeAnswer = !usedAnswers.has(answer);
        const isCorrect = correctAnswers.includes(answer) && isFirstTimeAnswer; // ตรวจสอบว่าเป็นคำตอบที่ถูกต้องและเป็นคำตอบแรกที่พบ
        if (isCorrect) {
          usedAnswers.add(answer);
        }
        _selectedAnswers.push({
          value: answer,
          label: answer,
          result: isCorrect ? RESULT_TYPE.CORRECT : RESULT_TYPE.INCORRECT,
        });
      }
      selectedAnswer = _selectedAnswers.length ? _selectedAnswers : null;
    } else {
      const { choices } = metadata;
      const _selectedAnswer = choices.find((c) => {
        return c.value === answer.value;
      });
      if (!isNil(_selectedAnswer)) {
        selectedAnswer = [
          {
            value: _selectedAnswer.value,
            label: _selectedAnswer.label,
            result: isCorrect ? RESULT_TYPE.CORRECT : RESULT_TYPE.INCORRECT,
          },
        ];
      }
    }
    return selectedAnswer;
  };

  return (
    <QueryComponent
      query={getClassroomQuizExamPaperItemSolutionById}
      variables={{ examSessionId, examPaperItemId }}
    >
      {(data) => {
        const {
          isCorrect,
          solution,
          answer,
          metadata,
          question,
          correctAnswer,
          type,
          scoreRatio,
          examScoreScale,
          passage,
        } = data.classroomQuizExamPaperItem || {};
        const selectedAnswer = renderSelectedAnswer(
          type,
          answer,
          correctAnswer,
          isCorrect,
          metadata
        );
        const score = examScoreScale ? scoreRatio * examScoreScale : scoreRatio;

        return children({
          onBack: handleGoToSolutionListView,
          isFirstQuestion: currentQuestionIndex <= 0,
          isLastQuestion: currentQuestionIndex >= results.length - 1,
          onGoToNextQuestion: handleGoToNextQuestion,
          onGoToPreviousQuestion: handleGoToPreviousQuestion,
          solutionContent: solution,
          questionNo: currentQuestionIndex + 1,
          questionContent: question,
          result: isCorrect ? RESULT_TYPE.CORRECT : RESULT_TYPE.INCORRECT,
          selectedAnswer,
          isShowScore,
          score,
          passage,
        });
      }}
    </QueryComponent>
  );
};

export default withRouter(SolutionDetail);
